<template>
   <!-- Campana de la barra superior: historial de los envíos de Registro
        Académico. Se ve desde cualquier pantalla, pero el procesamiento sigue
        ocurriendo en Dirección de Integración: al elegir un mes se abre esa
        pantalla con el detalle del envío. -->
   <v-menu
      v-model="abierto"
      offset-y
      left
      :close-on-content-click="false"
      max-width="460"
   >
      <template #activator="{ on }">
         <v-btn
            icon
            class="mr-2"
            title="Notificaciones de Integración"
            v-on="on"
         >
            <v-badge
               :value="pendientes > 0"
               :content="pendientes"
               color="red"
               overlap
            >
               <v-icon>fas fa-bell</v-icon>
            </v-badge>
         </v-btn>
      </template>

      <v-card>
         <v-card-title class="text-subtitle-1">
            Envíos de Registro Académico
         </v-card-title>
         <v-divider />
         <v-list dense max-height="420" class="overflow-y-auto">
            <v-list-item v-if="!envios.length">
               <v-list-item-content>
                  <v-list-item-subtitle>
                     Registro Académico todavía no ha habilitado ningún mes.
                  </v-list-item-subtitle>
               </v-list-item-content>
            </v-list-item>

            <v-list-item
               v-for="e in envios"
               :key="e.anio + '-' + e.mes"
               :link="puedeAbrir"
               @click="abrir(e)"
            >
               <v-list-item-content>
                  <v-list-item-title>
                     {{ e.mesNombre }} {{ e.anio }}
                     <v-chip
                        x-small
                        label
                        class="ml-1"
                        :color="colorEstado(e.estado)"
                        text-color="white"
                     >
                        {{ etiquetaEstado(e.estado) }}
                     </v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-caption">
                     Habilitado el {{ e.fechaEnvio || '—' }} ·
                     {{ e.filas }} alumno(s)
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="e.importado" class="text-caption">
                     Procesado el {{ e.importadoEl }}
                     <span v-if="e.importadoPor">por {{ e.importadoPor }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                     v-else-if="e.descartado"
                     class="text-caption"
                  >
                     Se conservó lo cargado por Excel el {{ e.descartadoEl }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                     v-if="e.hayCambios"
                     class="text-caption orange--text text--darken-3"
                  >
                     Modificado por Registro Académico el {{ e.fechaCambio }}
                  </v-list-item-subtitle>
               </v-list-item-content>
               <v-list-item-action v-if="puedeAbrir">
                  <v-icon small color="grey">fas fa-chevron-right</v-icon>
               </v-list-item-action>
            </v-list-item>
         </v-list>

         <template v-if="!puedeAbrir && envios.length">
            <v-divider />
            <v-card-text class="text-caption grey--text py-2">
               Para procesar estos listados se requiere acceso a la pantalla
               Dirección de Integración.
            </v-card-text>
         </template>
      </v-card>
   </v-menu>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../../helpers'
import {
   colorEstado,
   etiquetaEstado,
   esPendiente,
   EVENTO_ENVIOS_ACTUALIZADOS
} from './estadoEnvio'

/**
 * Quién la ve lo decide App.vue con el permiso 36 (Notificaciones). Abrir el
 * detalle de un envío exige además el 34, que es el que deja entrar a la
 * pantalla de Integración: sin él, la campana solo informa.
 */
export default {
   name: 'CampanaIntegracion',
   data() {
      return {
         abierto: false,
         envios: []
      }
   },
   computed: {
      ...authComputed,
      pendientes() {
         return this.envios.filter(esPendiente).length
      },
      puedeAbrir() {
         // try/catch: permController revienta si el usuario no tiene fila para
         // ese controlador en UsuarioPermisos.
         try {
            return !!this.permController(34, 'ver')
         } catch (e) {
            return false
         }
      }
   },
   watch: {
      // Se refresca al abrirla, para que el historial no quede viejo si la
      // pantalla lleva rato abierta.
      abierto(val) {
         if (val) this.cargar()
      }
   },
   created() {
      this.cargar()
      this.$root.$on(EVENTO_ENVIOS_ACTUALIZADOS, this.cargar)
   },
   beforeDestroy() {
      this.$root.$off(EVENTO_ENVIOS_ACTUALIZADOS, this.cargar)
   },
   methods: {
      colorEstado,
      etiquetaEstado,
      cargar() {
         axios
            .get('api/Integracion/padron-ra/envios')
            .then(({ data }) => {
               this.envios = data || []
            })
            .catch((error) => console.log(error))
      },
      /**
       * Lleva a Dirección de Integración con el mes en la dirección; la pantalla
       * lo lee y abre el detalle del envío desde ahí.
       */
      abrir(envio) {
         if (!this.puedeAbrir) return

         this.abierto = false
         this.$router
            .push({
               name: 'direccionIntegracion',
               query: { envioAnio: envio.anio, envioMes: envio.mes }
            })
            // Volver a elegir el mismo mes estando ya en la pantalla no es un
            // error: el router solo avisa que la ruta es la misma.
            .catch(() => {})
      }
   }
}
</script>
